import React, { useMemo, useState } from 'react';
import { X, Plus, Save, Trash2, Settings2 } from 'lucide-react';
import api from '../utils/api';

const createOption = (value = '') => ({
  id: `company_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  value,
});

export default function SettingDataModal({ onClose, settings, onUpdated }) {
  const initialOptions = useMemo(() => {
    const options = settings?.task_company_options || [];
    return options.length ? options.map((value) => createOption(value)) : [createOption('The Little Bean')];
  }, [settings]);

  const [companyOptions, setCompanyOptions] = useState(initialOptions);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const updateOption = (id, value) => {
    setCompanyOptions((prev) => prev.map((item) => (item.id === id ? { ...item, value } : item)));
  };

  const removeOption = (id) => {
    setCompanyOptions((prev) => (prev.length > 1 ? prev.filter((item) => item.id !== id) : prev));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = companyOptions.map((item) => item.value.trim()).filter(Boolean);
    if (!payload.length) {
      setError('Bạn cần có ít nhất 1 công ty trong danh sách.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      const data = await api.updateSettings({ task_company_options: payload });
      onUpdated?.(data.settings || { task_company_options: payload });
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Settings2 size={18} /> Setting Data
          </div>
          <button className="btn-icon" onClick={onClose} type="button"><X size={18} /></button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body stack-gap-lg">
            {error && <div className="alert alert-error">{error}</div>}

            <div>
              <div className="profile-items-head" style={{ marginBottom: 12 }}>
                <div>
                  <div className="form-label">Danh sách công ty cho Task thuộc công ty</div>
                  <div className="form-hint">Có thể đổi tên, thêm mới hoặc xoá từng lựa chọn trong form select của task.</div>
                </div>
                <button className="btn btn-ghost btn-sm" type="button" onClick={() => setCompanyOptions((prev) => [...prev, createOption('')])}>
                  <Plus size={14} /> Thêm công ty
                </button>
              </div>

              <div className="profile-item-list">
                {companyOptions.map((item, index) => (
                  <div className="profile-item-editor compact-setting-row" key={item.id}>
                    <div className="profile-item-icon-preview">{index + 1}</div>
                    <div className="profile-item-editor-grid setting-data-grid">
                      <div className="form-group">
                        <label className="form-label">Tên công ty</label>
                        <input
                          className="form-input"
                          value={item.value}
                          onChange={(e) => updateOption(item.id, e.target.value)}
                          placeholder="Ví dụ: LATVN"
                        />
                      </div>
                    </div>
                    <button className="btn-icon danger-icon" type="button" onClick={() => removeOption(item.id)} title="Xoá lựa chọn">
                      <Trash2 size={15} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-ghost" type="button" onClick={onClose}>Đóng</button>
            <button className="btn btn-primary" type="submit" disabled={saving}>
              <Save size={15} /> {saving ? 'Đang lưu...' : 'Lưu Setting'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
